module.exports = __webpack_public_path__ + "static/media/mk_flag.bc0a477d.svg";